import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    background: p => `${p.tertiaryDark}`,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryDark,
    ctaTitle: p => p.tertiaryDark,
    ctaParagraph: p => p.tertiaryNormal,
    raisedShadow: () => 'none',
    buttonShadow: () => 'none'
  },
  LIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal,
    background: p => `${p.tertiaryLight}`,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryLight,
    ctaTitle: p => p.tertiaryDark,
    ctaParagraph: p => p.tertiaryNormal
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal,
    lightBackground: p => p.tertiaryExtraLight,
    background: p => `${p.tertiaryExtraLight}`,
    backgroundColor: p => p.tertiaryExtraLight,
    ctaTitle: p => p.tertiaryDark,
    ctaParagraph: p => p.tertiaryNormal
  }
}
